module.exports = __webpack_public_path__ + "img/whatsapp.e120b93a.gif";